import React from 'react'
import PropTypes from 'prop-types'
import { allLenders as allStudentLoanLenders } from 'student-loan/rate-table/lenders-data'
import { allLenders as allPersonalLoanLenders } from 'personal-loan/rate-table/lenders-data'
import { allLenders as allStudentLoanRefiLenders } from 'student-loan-refi/rate-table/lenders-data'
import styles from './styles.module.scss'

const setPartnerCls = (partner) => {
    const allLenders = [
        ...allStudentLoanLenders,
        ...allPersonalLoanLenders,
        ...allStudentLoanRefiLenders,
      ],
      lender = allLenders.find(l => l.slug === partner)

    return lender ? styles[partner] : styles.default
  },

  PartnerLogo = ({ type, partner, className }) => {
    const cls = `${styles['lender-logo']} ${setPartnerCls(partner)} ${styles[type]} ${className}`

    return (
      <div className={cls} />
    )
  }

PartnerLogo.propTypes = {
  partner: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['normal', 'icon']),
  className: PropTypes.string,
}

PartnerLogo.defaultProps = {
  type: 'normal',
  className: '',
}

export { PartnerLogo, setPartnerCls }
